import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setAuthUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { nav("/login"); return; }
      const session_id = decodeURIComponent(m[1]);
      try {
        const referral = localStorage.getItem("loom_ref") || undefined;
        const r = await api.post("/auth/session", { session_id, referral });
        localStorage.removeItem("loom_ref");
        // Store the session token so it's also sent as a Bearer fallback when the
        // httpOnly cookie is blocked (embedded preview / 3rd-party cookie blocking).
        if (r.data.token) localStorage.setItem("loom_token", r.data.token);
        setAuthUser(r.data.user);
        // remove hash from URL
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { state: { user: r.data.user } });
      } catch (e) {
        nav("/login");
      }
    })();
  }, [nav, setAuthUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="font-hand text-3xl text-stone-500" data-testid="auth-callback-loading">
        signing you in…
      </div>
    </div>
  );
}
